import { IContractCancellationsRepository } from 'modules/customer/domain/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import VectisContractCancellationsRepository from './implementations/VectisContractCancellationsRepository';

let instance: IContractCancellationsRepository | null = null;

export default function makeContractCancellationsRepository() {
  if (!instance) {
    const httpProvider = makeHTTPProvider();

    instance = new VectisContractCancellationsRepository(httpProvider);
  }

  return instance;
}
